import { gql, useMutation } from 'urql';

export interface AddSecondaryGuestInput {
  input: {
    eventId: number;
    parentTicketId: number;
    submissionInfo: string;
  };
}

export interface AddSecondaryGuestResponse {
  addSecondaryGuest: {
    __typename?: string;
  };
}

export const ADD_SECONDARY_GUEST = gql`
  mutation AddSecondaryGuest($input: AddSecondaryGuestInput!) {
    addSecondaryGuest(input: $input) {
      __typename
    }
  }
`;

export const useAddSecondaryGuest = () => {
  const [{ data, error, fetching }, executeMutation] = useMutation<AddSecondaryGuestResponse, AddSecondaryGuestInput>(
    ADD_SECONDARY_GUEST
  );

  const addSecondaryGuest = (variables: AddSecondaryGuestInput) => executeMutation(variables);

  return { data, error, fetching, addSecondaryGuest };
};
